// Undo tip's confirm, everywhere it is offered (run detail → Tipping, the
// Tipping page, a delivery's tipping rows): reads what was packed from the tip
// first and puts it above the question (undoTipWarning.ts).
import { confirmDialog } from '@/components/Dialogs'
import { supabase } from '@/lib/supabase'
import { readTipPackout, undoTipWarnings } from '@/lib/undoTipWarning'

export async function confirmUndoTip(o: { tippingId: string; title?: string; message: string }): Promise<boolean> {
  const packed = await readTipPackout(supabase, o.tippingId)
  return confirmDialog({
    title:    o.title,
    message:  o.message,
    warnings: undoTipWarnings(packed),
    confirm:  'Undo tip',
    tone:     'danger',
  })
}
